import { AuthEnum, AuthProps } from "./auth.props";

const authReducers = (
  state: AuthProps,
  action: { type: AuthEnum; payload: any }
) => {
  switch (action.type) {
    case AuthEnum.LOGIN:
      return {
        ...state,
        isLoggedIn: action.payload,
      };

    case AuthEnum.TOKEN:
      return {
        ...state,
        token: action.payload,
      };

    case AuthEnum.USER:
      return {
        ...state,
        user: action.payload,
      };

    case AuthEnum.ROL:
      return {
        ...state,
        rol: action.payload,
      };

    case AuthEnum.SESSION:
      return {
        ...state,
        session: action.payload,
      };

    default:
      return state;
  }
};

export default authReducers;
